import { communityStats } from '@/mocks/siteData';

export default function CommunityStatsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-foreground-400 text-sm font-medium font-heading mb-3">我们的成绩</p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            千万瓜友的
            <span className="italic text-accent-600 font-serif">共同选择</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-lg mx-auto">
            数据不会说谎，来看看91吃瓜社区的真实影响力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="p-8 md:p-10 rounded-2xl bg-primary-100/70 relative overflow-hidden group cursor-default">
            <div className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/80">
              <i className="ri-arrow-right-up-line text-primary-600 text-lg"></i>
            </div>
            <div className="text-6xl md:text-7xl font-heading font-bold text-primary-600 mb-4">
              {communityStats.totalMembers >= 10000
                ? `${(communityStats.totalMembers / 10000).toFixed(0)}万+`
                : communityStats.totalMembers.toLocaleString()}
            </div>
            <p className="text-foreground-700 text-lg md:text-xl leading-relaxed mb-6">
              注册瓜友总数，遍布全国各地，<br />一起在线吃瓜聊八卦
            </p>
            <p className="text-foreground-500 text-sm italic">数据截止2026年7月</p>
          </div>

          <div className="p-8 md:p-10 rounded-2xl bg-accent-100/70 relative overflow-hidden group cursor-default">
            <div className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/80">
              <i className="ri-arrow-right-up-line text-accent-600 text-lg"></i>
            </div>
            <div className="text-6xl md:text-7xl font-heading font-bold text-accent-600 mb-4">
              {communityStats.monthlyGrowth}%
            </div>
            <p className="text-foreground-700 text-lg md:text-xl leading-relaxed mb-6">
              月均活跃用户增长率，<br />
              社区规模持续高速扩张，越来越多的吃瓜群众选择加入91吃瓜大家庭，每天都有新鲜血液涌入。
            </p>
            <p className="text-foreground-500 text-sm italic">同比增长数据</p>
          </div>
        </div>

        <div className="mt-5 grid grid-cols-2 gap-5">
          <div className="p-6 md:p-8 rounded-2xl bg-background-100 text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {communityStats.totalPosts >= 10000
                ? `${(communityStats.totalPosts / 10000).toFixed(0)}万+`
                : communityStats.totalPosts.toLocaleString()}
            </div>
            <p className="text-foreground-500 text-sm mt-1">累计爆料帖子</p>
          </div>
          <div className="p-6 md:p-8 rounded-2xl bg-background-100 text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {communityStats.dailyActive >= 10000
                ? `${(communityStats.dailyActive / 10000).toFixed(1)}万`
                : communityStats.dailyActive.toLocaleString()}
            </div>
            <p className="text-foreground-500 text-sm mt-1">日均活跃用户</p>
          </div>
        </div>
      </div>
    </section>
  );
}